module.exports = __webpack_public_path__ + "static/images/397e2401.png";